var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { Long, Timestamp } from 'streem-sdk-protobuf';
export class TimeStampController {
    constructor(videoArtifacts) {
        this._videoElements = [];
        this.convertSecondsToTimestamp = (time) => {
            return new Timestamp({
                seconds: new Long(time),
                nanos: ((time * 1000) % 1000) * 1e6,
            });
        };
        this.getStreemShotTimeStamp = ({ clientCreatedAt, }) => {
            if (!this.videoCreatedAt || !clientCreatedAt)
                return '';
            const nanos = clientCreatedAt.nanos || 0;
            const streemShotCreatedAtTime = clientCreatedAt.seconds.low + nanos / 1000000000;
            const secondsElapsedSinceVideoStart = streemShotCreatedAtTime - this.videoCreatedAt;
            return this.convertTimeStampToReadableString(secondsElapsedSinceVideoStart);
        };
        this.getBookmarkTimeStamp = (bookmark) => {
            const { timestamp } = bookmark;
            if (!timestamp || !this.videoCreatedAt)
                return '';
            const nanos = timestamp.nanos || 0;
            const bookmarkCreatedAtTime = timestamp?.seconds.low + nanos / 1000000000;
            const secondsElapsedSinceVideoStart = bookmarkCreatedAtTime - this.videoCreatedAt;
            return this.convertTimeStampToReadableString(secondsElapsedSinceVideoStart);
        };
        this.getNewBookmarkTimeStamp = () => {
            if (!this.videoCreatedAt)
                return 0;
            return this.videoCreatedAt + this.currentPlaybackTime;
        };
        this._videoArtifacts = videoArtifacts;
    }
    // Video elements must first be registered before the time stamp is set on them
    registerVideoElement(videoElement) {
        if (!this._videoElements.includes(videoElement)) {
            this._videoElements.push(videoElement);
        }
        return;
    }
    jumpVideoToTimeStamp(createdAtTime) {
        if (this._videoElements.length === 0) {
            throw new Error('You must register at least 1 video element before setting the time stamp');
        }
        this._videoElements.forEach(videoEl => {
            const videoCreatedAt = this.videoCreatedAt ?? 0;
            videoEl.currentTime = createdAtTime - videoCreatedAt;
        });
    }
    get hasVideoArtifact() {
        return this._videoArtifacts.length > 0;
    }
    get hasVideoElement() {
        return this._videoElements.length > 0;
    }
    get videoCreatedAt() {
        const nanos = this._videoArtifacts[0]?.clientCreatedAt?.nanos ?? 0;
        return this._videoArtifacts[0]?.clientCreatedAt?.seconds.low + nanos / 1000000000;
    }
    get currentPlaybackTime() {
        return this._videoElements[0].currentTime;
    }
    convertTimeStampToReadableString(secondsElapsed) {
        const minutes = Math.floor(secondsElapsed / 60);
        const seconds = Math.floor(secondsElapsed % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
}
__decorate([
    observable
], TimeStampController.prototype, "_videoArtifacts", void 0);
__decorate([
    observable
], TimeStampController.prototype, "_videoElements", void 0);
__decorate([
    action
], TimeStampController.prototype, "registerVideoElement", null);
__decorate([
    computed
], TimeStampController.prototype, "hasVideoArtifact", null);
__decorate([
    computed
], TimeStampController.prototype, "hasVideoElement", null);
__decorate([
    computed
], TimeStampController.prototype, "videoCreatedAt", null);
//# sourceMappingURL=timestamp_controller.js.map